<template>
<div class="license-info" :class="isActivated">
	<header>
		<img src="@/assets/img/kolkin-sos-icon.png" />
		<b>{{license.product_name}}</b>
	</header>
    <p><b>Version:</b>  {{license.version}}</p>
	<p><b>Licensed to:</b>  {{license.licensee}}</p>
	<p :class="{'activated':license.activated == 't'}"><b>Activation Code:</b> {{license.activation_code}} <span v-if="license.activated == 't'"> (Activated)</span></p>

    <p>Software Download</p>
    <div class="downloads">
        <a :class="{'active':isWindows}" :href="'/sos/download/sos.msi?fingerprint='+fingerprint" download><i class="icon icon-brand-microsoft"></i> Windows</a>
        <a @click="macDownloadClick" :id="'macButton'+license.activation_code" :class="{'active':isMac}"><i class="icon icon-brand-apple"></i> Mac</a>
        <Popper ref="macDownloads" :target_id="'macButton'+license.activation_code" :placement="'bottom-start'" :append_to_body="true" :offset="[0,2]">
        	<div class="dropdown-menu mac-downloads">
         		<a :href="'/sos/download/arm/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Apple Silicon </a>
           		<a :href="'/sos/download/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Intel </a>
        	</div>
        </Popper>
    </div>


	<button v-if="license.is_recurring=='t'" @click="$router.push({name:'license-invoice',params:{license:license.license_uuid}})" class="payment-button">
        Payment Details <i class="icon icon-chevron-right"></i>
    </button>
    <span v-if="license.trial=='t'" class="payment-button">
        Trial License
    </span>
</div>
</template>

<script>

import Popper from "@/../submodules/vue-base/components/Popper";

export default {
    name: "License",

    components: {
    	Popper
    },

    props: {
        license: {},
        isMac: {
            type: Boolean,
            default: false
        },
        isWindows: {
            type: Boolean,
            default: false
        },
        fingerprint: {
            type: String,
            default: ""
        }
    },

    methods: {
    	macDownloadClick(){
			this.$refs.macDownloads.toggle();
     	},
    },

    computed: {
        isActivated() {
            return {
                'grayout': this.license.activated == 't',
            };
        }
    },
}
</script>
